/**
 * Unified Page Loading State Component
 * Full-page loading overlay for initial page loads
 */

import React from 'react';
import Spinner from '../ui/Spinner';
import {AppText} from '../ui/Typography';

interface PageLoadingStateProps {
  message?: string;
  overlay?: boolean;
  className?: string;
}

export const PageLoadingState: React.FC<PageLoadingStateProps> = ({
  message = 'جاري التحميل...',
  overlay = false,
  className = ''
}) => {
  const containerClass = overlay
    ? 'fixed inset-0 bg-white/80 backdrop-blur-sm z-50 flex items-center justify-center'
    : 'flex items-center justify-center py-12';

  return (
    <div className={`${containerClass} ${className}`}>
      <div className="flex flex-col items-center gap-4">
        <Spinner size={48} />
        <AppText className="text-gray-600 font-medium">{message}</AppText>
      </div>
    </div>
  );
};

export default PageLoadingState;


